<template>
  <el-form-item 
    v-if="visible"
    :label="$t('lang.加热温度') + '：'">
    <el-select 
      :disabled="disabled"
      @change="handleChange" 
      default-first-option
      :placeholder="$t('lang.请选择')"
      v-model="localValue" 
      filterable>
      <el-option :label="0" :value="0" />
      <el-option :label="37" :value="37" />
      <el-option 
        v-for="t in temperatureOptions"
        :key="'temperature_' + t" 
        :label="t"
        :value="t"/>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'Temperature',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('HEAT_TEMP');
    },
    disabled() {
      if (!this.permissions.includes('HEAT_TEMP')) return true;
      return !this.devMode?.tempChange;
    },
    temperatureOptions() {
      if (!this.devMode) return [];
      const options = [];
      for (let t = this.devMode.minTemp; t <= this.devMode.maxTemp; t++) {
        if (t % 5 === 0 && t > 37) {
          options.push(t);
        }
      }
      return options;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

